import React from 'react';

import { createServicePageLayoutClassName } from './servicePageLayoutStyles';
import { ServiceHeaderLayoutComponent } from 'design/serviceHeaderLayout';

type Props = {
  size?: 'auto';
  theme?: 'light' | 'dark';
  logo: React.ReactNode;
  bodyContent: React.ReactNode;
  accountControls?: React.ReactNode;
};

export const ServicePageLayoutComponent = (props: Props) => {
  const {
    size = 'auto',
    theme = 'light',
    logo,
    bodyContent,
    accountControls,
  } = props;

  const wrapperClassName = createServicePageLayoutClassName('wrapper', {
    theme,
  });

  const bodyClassName = createServicePageLayoutClassName('body');

  const bodyContentClassName = createServicePageLayoutClassName('bodyContent', {
    size,
  });

  return (
    <div className={wrapperClassName}>
      <ServiceHeaderLayoutComponent
        logo={logo}
        accountControls={accountControls}
        size={size}
      />
      <div className={bodyClassName}>
        <div className={bodyContentClassName}>{bodyContent}</div>
      </div>
    </div>
  );
};
